import { useQuery } from '@tanstack/react-query';
import { transactionsService } from 'commons/services';
import { TransactionStatusType } from 'commons/types';

export function useHasTransactions(params?: {
  status?: TransactionStatusType[];
}) {
  const queryResult = useQuery(['hasTransactions'], () =>
    transactionsService.getHasTransactions(params),
  );

  return {
    isLoading: queryResult.isLoading,
    hasTransactions: queryResult.data?.hasTransactions,
  };
}
